import { Injectable } from '@angular/core';
import { vectorTaggingToolsConfig } from '../../../../cross-team-shared/tools.config';
import { AbstractShapeTool2D } from '../shared/abstract-shape-tool-2d';
import { SingleClickShapeToolHelper } from './single-click-shape-tool-helper';

@Injectable()
export class PointTool extends AbstractShapeTool2D {
  readonly name = vectorTaggingToolsConfig.Point.name;

  override async onActivate() {
    await super.onActivate();
    this.onEvent('container', 'mousedown', () => {
      new SingleClickShapeToolHelper(
        this,
        this.store('vectorOverlay'),
        this.injector,
      ).createShape();
    });
  }
}
